import { KeyboardArrowUp as KeyboardArrowUpIcon } from '@mui/icons-material';

const KeyboardArrowUp = (): JSX.Element => <KeyboardArrowUpIcon fontSize="inherit" />;

export default KeyboardArrowUp;
